export default __webpack_public_path__ + "static/media/tutorial-find-link-1.675e9ad1.png";